module.exports = __webpack_public_path__ + "static/media/how-it-works.48e6ba0f.png";